module.exports = __webpack_public_path__ + "img/facebook.e715c46d.svg";